/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

// Importing icons for editing and deleting
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";

export default function Tr({
  id, // Unique identifier for the pattern
  order, // Order of the item in the table
  pattern_name, // Name of the pattern
  thumbnail_url, // URL for the pattern thumbnail
  thumbnail_url_preview,
  art_pack_id, // ID for the associated art pack
  onEdit, // Function to handle the edit action
  onDelete, // Function to handle the delete action
  isAllowedToEditOrDelete, // Boolean to control edit/delete permissions
}) {
  return (
    <>
      <tr>
        <td className="col-numeric-date">{order}</td> {/* Display the order number */}
        <td className="col-numeric-date">{pattern_name}</td> {/* Display the pattern name */}
        <td className="col-numeric-date">
          {/* Display the thumbnail image */}
          <img src={thumbnail_url_preview} width={50} height={50} alt={thumbnail_url} />
        </td>
        <td className="col-options">
          {/* Edit action */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete // Check if editing is allowed
                ? onEdit({
                    id, // Pass the id for editing
                    pattern_name, // Pass the pattern name for editing
                    thumbnail_url, // Pass the thumbnail URL for editing
                    art_pack_id, // Pass the art pack ID for editing
                    thumbnail_url_preview,
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons" src={edit_logo} alt="Edit" /> {/* Edit icon */}
          </a>
          &nbsp;
          {/* Delete action */}
          <a
            onClick={(e) => {
              isAllowedToEditOrDelete // Check if deletion is allowed
                ? onDelete({
                    id, // Pass the id for deletion
                    pattern_name, // Pass the pattern name for deletion
                    thumbnail_url, // Pass the thumbnail URL for deletion
                    art_pack_id, // Pass the art pack ID for deletion
                    delete: true, // Indicate this is a delete action
                  })
                : e.preventDefault(); // Prevent default action if not allowed
            }}
            style={{
              cursor: isAllowedToEditOrDelete ? "pointer" : "not-allowed", // Change cursor based on permission
            }}
          >
            <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" /> {/* Delete icon */}
          </a>
          &nbsp;
        </td>
      </tr>
    </>
  );
}
